import { useCallback, useState } from 'react';
import { useInfiniteResource } from 'hooks/useInfiniteResource';
import salesforceAccountsService from 'services/salesforceAccountsService';

const PER_PAGE = 25;

// assignedToMe isn't part of useInfiniteResource's contract, so it's captured per page.
const useAccounts = (filters = {}, sort = {}) => {
	const [assignedToMe, setAssignedToMe] = useState(null);

	const fetchFn = useCallback(async (page) => {
		const response = await salesforceAccountsService.getAccounts(
			page,
			PER_PAGE,
			filters,
			sort
		);
		setAssignedToMe(response.assignedToMe);
		return response;
	}, [filters, sort]);

	const {
		data,
		totalCount,
		loading,
		loadingMore,
		error,
		hasMore,
		loadMore,
		refresh,
	} = useInfiniteResource({ fetchFn });

	return {
		accounts: data,
		totalCount,
		assignedToMe,
		loading,
		loadingMore,
		error,
		hasMore,
		loadMore,
		refresh,
	};
};

export default useAccounts;
